(function () {
  var _lastWidth = window.innerWidth;
  var _resizeTimer;

  function swiperInit() {
    try { subSliderInit(true); } catch (e) { console.warn('subSliderInit error:', e); }
    try { sliderInit(true); } catch (e) { console.warn('sliderInit error:', e); }
  }

  function safeDestroy(el) {
    try {
      if (el.swiper) el.swiper.destroy(true, true);
    } catch (e) {}
  }

  document.addEventListener('shopify:section:load', function () {
    swiperInit();
  });

  window.addEventListener('resize', function () {
    var newWidth = window.innerWidth;

    // Ignore vertical-only resize (mobile address bar, keyboard, etc.)
    if (newWidth === _lastWidth) return;
    _lastWidth = newWidth;

    // Debounce so rapid resize events don't stack
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(function () {
      $('.product-section .js-media-list').each(function () {
        safeDestroy(this);
      });
      $('.product-section .js-media-sublist').each(function () {
        safeDestroy(this);
      });

      swiperInit();
    }, 250);
  });

  swiperInit();
})();
